import { LitElement, html, css, PropertyValueMap } from 'lit';
import { customElement, property } from 'lit/decorators.js';
// import {classMap} from 'lit/directives/class-map.js';
import { bindEvent, Handler } from '@gsmlg/utils/dist/browser/bindEvent';
import '../icons/bars';

@customElement('app-navigator-menu')
class AppNavigatorMenuElement extends LitElement {
  static override styles = css`
    :host {
      display: inline-flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      color: var(--app-navigator-menu-color, #362424);
      background-color: var(--app-navigator-menu-background-color, transparent);
    }

    .submenu {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding-left: 1rem;
    }
    @media only screen and (max-width: 992px) {
      .submenu {
        disply: none;
      }
    }
  `;

  @property({ type: String, attribute: 'color', reflect: true })
  color: string | undefined = undefined;

  @property({ type: String, attribute: 'background-color', reflect: true })
  backgroundColor: string | undefined = undefined;

  _elHandlers: Handler[] = [];

  isMobile: boolean = false;

  submenuIsOpen: boolean = false;

  constructor() {
    super();

    this.handleSubmenuIsOpen.bind(this);

    this._setColor();
  }

  override connectedCallback() {
    super.connectedCallback();
    this._elHandlers.push(this.handleScroll());
    this._elHandlers.push(this.handleMenuWhenMQChange());
  }

  override disconnectedCallback() {
    if (this._elHandlers.length > 0) {
      this._elHandlers.forEach(({ release }) => release());
    }
    super.disconnectedCallback();
  }

  protected override firstUpdated(
    _changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>,
  ): void {
    super.firstUpdated(_changedProperties);
    this._setColor();
  }

  override attributeChangedCallback(
    name: string,
    old: string | null,
    value: string | null,
  ) {
    super.attributeChangedCallback(name, old, value);
    if (name === 'color') {
      this.style.color = this.color as string;
    }
    if (name === 'background-color') {
      this.style.backgroundColor = this.backgroundColor as string;
    }
    this.requestUpdate();
  }

  override render() {
    return html`
      <div
        role="menuitem"
        class="menu-submenu-title"
        @click=${this.handleSubmenuIsOpen}
        aria-expanded="false"
        aria-haspopup="true"
      >
        <span class="menu-title-content">
          <slot></slot>
        </span>
      </div>
      ${this.submenuIsOpen
        ? html`
            <div class="submenu">
              <slot name="submenu"></slot>
            </div>
          `
        : ''}
    `;
  }

  private handleMenuWhenMQChange() {
    this.isMobile = !window.matchMedia('(min-width: 992px)').matches;
    return bindEvent(window.matchMedia('(min-width: 992px)'), 'change', ({ matches }) => {
      if (matches) {
        this.submenuIsOpen = false;
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
      this.classList.remove('hide');
      this.requestUpdate();
    });
  }

  private _setColor() {
    if (this.color) {
      this.style.color = this.color;
    }
    if (this.backgroundColor) {
      this.style.backgroundColor = this.backgroundColor;
    }
  }

  private handleScroll() {
    if (this.parentElement) {
      let lastKnownScrollPosition = window.scrollY;
      return bindEvent(window, 'scroll', (_evt: Event) => {
        if (this.isMobile) {
          if (lastKnownScrollPosition < window.scrollY) {
            this.classList.add('hide');
          } else {
            this.classList.remove('hide');
          }
        }
        lastKnownScrollPosition = window.scrollY;
      });
    }
    return {
      release: () => {},
    };
  }

  private handleSubmenuIsOpen() {
    this.submenuIsOpen = !this.submenuIsOpen;
    this.requestUpdate();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'app-navigator-menu': AppNavigatorMenuElement;
  }
}
